import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from '@emotion/styled';
import useUserContext from '../hooks/use-user-context';
import { createOptionMap } from '../utilities/misc';
import { rem } from '../utilities/style';
import { containerStyles } from '../styles/layout';
import { ReactComponent as Arrow } from '../images/icons/small-arrow-left.svg';
import { colors } from '../theme/colors';

const Container = styled.div`
  display: flex;
  align-items: center;
  background-color: ${colors.gray['50']};
  color: ${colors.blue['800']};
  transition: height 200ms ease;
  height: ${rem(30)};
  border-bottom: 1px solid ${colors.gray['100']};
  border-top: 1px solid ${colors.gray['100']};
  transition: height 200ms ease;

  ${({ dark }) => dark && `
    background-color: ${colors.gray['800']};
    color: ${colors.gray['200']};
  `}

  ${({ scrolled }) => scrolled && `
    height: 0;
    pointer-events: none;
    overflow: hidden;
    border: none;
  `}
`;

const ContentWrapper = styled.div`
  ${containerStyles.regular}
`;
const StyledArrow = styled(Arrow)`
  transition: transform 200ms ease;
`;

const Link = styled.a`
  display: flex;
  align-items: center;
  gap: ${rem(6)};
  font-size: ${rem(12)};
  color: inherit;

  &:hover {
    text-decoration: underline;

    ${StyledArrow} {
      transform: translateX(${rem(-4)});
    }
  }

`;

const BackToHome = ({ scrolled, dark }) => {
  const data = useStaticQuery(graphql`
  query BackToHome {
    allContentfulOptionSet(filter: {name: {eq: "back_to_home"}}) {
      nodes {
        ...OptionSetFragment
      }
    }
  }
`);
  const { language } = useUserContext();
  const options = createOptionMap(data.allContentfulOptionSet.nodes, language);

  return (
    <Container scrolled={scrolled} dark={dark}>
      <ContentWrapper>
        <Link href="/">
          <StyledArrow />
          {options['back_to_home.button_text']}
        </Link>
      </ContentWrapper>
    </Container>
  );
};

export default BackToHome;
